import { assert } from 'light-infra';
import { Key } from '../key';
import { MultipartFormData } from './multipart';
import type { FormDataParams } from './types';

export class AliOSSMultipartFormData extends MultipartFormData<FormDataParams> {

  build(): FormData {
    assert(this.option != null, 'option is required');
    assert(this.option.code != null, 'code is required');
    assert(this.option.env != null, 'env is required');
    assert(this.option.policy != null, 'policy is required');
    assert(this.option.accessid != null, 'accessid is required');
    assert(this.option.signature != null, 'signature is required');

    const formData = new FormData();
    const fileKey = new Key().generate(this.option.code, this.option.env);

    formData.set('success_action_status', '200');
    formData.set('response_content_type', 'application/json');
    formData.set('key', fileKey);
    formData.set('policy', this.option.policy);
    formData.set('OSSAccessKeyId', this.option.accessid);
    formData.set('Signature', this.option.signature);
    formData.set('file', this.file);

    return formData;
  }

}
